import React from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { isShapeSmile } from 'sharedParts/utils/validateScaleShapeType';

const RatingItemIcon = ({ className, onClick = noop, style, e2e, shape, icon }) => (
  <span data-e2e={e2e} onClick={onClick} style={style} className={className}>
    {isShapeSmile(shape) && <FontAwesomeIcon icon={icon} style={{ ...style }} />}
  </span>
);

RatingItemIcon.propTypes = {
  e2e: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  shape: PropTypes.string,
  icon: PropTypes.object,
};

export default RatingItemIcon;
